import React from "react"
import { Card, CardBody, Col, Input, Label, Row } from "reactstrap"
import Switch from "react-switch"

function DeliveryAccess({ validation, openSection, toggleSection }) {

  const handleMultiSelect = (field, value, checked) => {
    const current = Array.isArray(validation.values[field])
      ? validation.values[field]
      : []

    let updated

    if (checked) {
      updated = current.includes(value)
        ? current
        : [...current, value]
    } else {
      updated = current.filter(v => v !== value)
    }

    validation.setFieldValue(field, updated)
  }
  const accessList = [
    { label: "Enable QR / Barcode", value: "enableQR" },
    // { label: "Enable Venue Gate Scanning", value: "enableVenueScan" },
    // { label: "Enable Session-wise Gate Scanning", value: "enableSessionScan" },
    // { label: "Enable ID Card", value: "enableID" },
  ]

  return (
    <>
      <div className="d-flex align-items-center mb-4">
        <div className="avatar-sm me-3">
          <span className="avatar-title rounded-circle bg-info bg-soft text-info font-size-18">
            <i className="mdi mdi-truck-delivery"></i>
          </span>
        </div>
        <div>
          <h5 className="mb-0 fw-semibold">Delivery & Access</h5>
          <small className="text-muted">Configure ticket delivery channels and access control</small>
        </div>
      </div>

      <Row className="gap-2 mb-2">
        <Col className="p-4 border border-info rounded">
          <div className="d-flex align-items-center mb-3">
            <i className="mdi mdi-send-circle-outline font-size-20 text-primary me-2"></i>
            <h6 className="mb-0 fw-semibold">Ticket Delivery Channels</h6>
          </div>
          {[
            { id: "isWallet", label: "Default (User Wallet)", value: "wallet", icon: "mdi-wallet-outline", disabled: true, defaultChecked: true },
            { id: "isEmail", label: "Email", value: "email", icon: "mdi-email-outline", disabled: false, defaultChecked: validation.values.deliveryChannels?.includes("email") },
            // { id: "isSMS", label: "SMS", value: "sms", icon: "mdi-message-text-outline", disabled: false, defaultChecked: validation.values.deliveryChannels?.includes("sms") },
            // { id: "isWhatsApp", label: "WhatsApp", value: "whatsapp", icon: "mdi-whatsapp", disabled: false, defaultChecked: validation.values.deliveryChannels?.includes("whatsapp") },
          ].map(ch => (
            <div
              key={ch.id}
              className="d-flex align-items-center justify-content-between p-2 rounded mb-2"
              style={{ backgroundColor: "#f8f9fa" }}
              onClick={e => e.stopPropagation()}
            >
              <div className="d-flex align-items-center gap-2">
                <i className={`mdi ${ch.icon} font-size-18 text-muted`}></i>
                <Label className="mb-0" htmlFor={ch.id}>{ch.label}</Label>
              </div>
              <Input
                type="checkbox"
                className="form-check-input"
                id={ch.id}
                style={{ width: 20, height: 20 }}
                disabled={ch.disabled}
                defaultChecked={ch.defaultChecked}
                onChange={e => handleMultiSelect("deliveryChannels", ch.value, e.target.checked)}
              />
            </div>
          ))}
        </Col>

        <Col className="p-4 border border-info rounded">
          <div className="d-flex align-items-center mb-3">
            <i className="mdi mdi-shield-lock-outline font-size-20 text-warning me-2"></i>
            <h6 className="mb-0 fw-semibold">Access Control</h6>
          </div>
          {accessList.map(item => (
            <div
              key={item.value}
              className="d-flex align-items-center justify-content-between p-2 rounded mb-2"
              style={{ backgroundColor: "#f8f9fa" }}
            >
              <Label className="mb-0">{item.label}</Label>
              <Input
                type="checkbox"
                style={{ width: 20, height: 20, cursor: "pointer" }}
                defaultChecked={validation.values[item.value]}
                onChange={e => {
                  const isChecked = e.target.checked
                  validation.setFieldValue(item.value, isChecked)
                  const current = Array.isArray(validation.values.accessControls) ? validation.values.accessControls : []
                  const updated = isChecked ? [...new Set([...current, item.value])] : current.filter(val => val !== item.value)
                  validation.setFieldValue("accessControls", updated)
                }}
              />
            </div>
          ))}
        </Col>
      </Row>
      <Row>
        <Col lg={12} className="p-4 border border-info rounded">
          <div
            className="d-flex justify-content-between align-items-center"
          >
            <div className="d-flex align-items-center gap-2">
              <i className="mdi mdi-form-select font-size-20 text-success"></i>
              <h6 className="mb-0 fw-semibold">Registration Fields</h6>
            </div>
          </div>
          <Row className="mt-3 pt-3 border-top g-3">
            {[
              { label: "First Name", field: "required_registration.enable_first_name", checked: validation.values.required_registration?.enable_first_name },
              { label: "Last Name", field: "required_registration.enable_last_name", checked: validation.values.required_registration?.enable_last_name },
              { label: "Email", field: "required_registration.enable_mail_id", checked: validation.values.required_registration?.enable_mail_id },
              { label: "Mobile Number", field: "required_registration.enable_mobile_number", checked: validation.values.required_registration?.enable_mobile_number },
              { label: "Age", field: "required_registration.enable_age", checked: validation.values.required_registration?.enable_age },
            ].map(reg => (
              <Col md={4} key={reg.field} className="d-flex align-items-center gap-2">
                <Switch
                  onColor="#34c38f"
                  offColor="#b3a692"
                  checked={reg.checked}
                  onChange={checked => validation.setFieldValue(reg.field, checked)}
                  height={16}
                  width={32}
                  uncheckedIcon={false}
                  checkedIcon={false}
                />
                <Label className="mb-0 small fw-medium">{reg.label}</Label>
              </Col>
            ))}
          </Row>
        </Col>
      </Row>
    </>
  )
}

export default DeliveryAccess
